import React from "react";
import useProducto from "../../Hooks/useProducto";
import Select from "react-select";
import SelectAsync from "react-select/async";
import { aCantidadBase, opcionesUnidades } from "../../Hooks/useUnidadLinea";
import { formatCurrency, money } from "../../../../utils/helpers";
import { auth } from "../../../../utils/auth";
import Modal from "../../../general/Modal";
import ItemFotos from "../../../Items/ItemFotos";

const ProductosCotizacionMobile = ({
    producto,
    productos,
	updateTotal,
	index,
	removeProducto,
	precioLimite,
	banderaContacto,
	impuestosForDropdown,
	facturaProductos,
	isEdit,
	errors,
	contacto
}) => {
    const {
        productoInfo,
        productLabelMobile,
        total,
        totalReal,
        preciosVenta,
        precioManual,
        pinSeguridad,
        productoITBIS,
        checkPINSeguridad,
        onChangeInput,
        onChangeImpuesto,
        onChangeProducto,
        onChangeCostoManual,
        onChangeUnidad,
        handlePrecioVentaChange,
        setProductoInfo,
        setPrecioManual,
        setPinSeguridad,
        setShowFotos,
        toggleFotosModal,
        toggleDeleteModal,
        togglePINModal,
        showPrecioManual,
        showFotos,
        showDelete,
        showPINModal,
        volverAlSelector,
        getProductos
    } = useProducto(producto, facturaProductos, updateTotal, index, impuestosForDropdown, banderaContacto, precioLimite, contacto, isEdit);
    

    return <>
        <fieldset
            className="fieldset my-2"
            style={{ border: "2px solid #008aab" }}
        >
            <legend>Producto {index + 1}</legend>
            <div className="col-12 px-0">
                <input
                    type="hidden"
                    name={`productos[${index}][id]`}
                    value={producto?.id ? producto.id : `random-${index}`}
                />
                <div className="form-group mb-1">
                    <label className="orden-filter-label">
                        Descripción
                    </label>
                    <SelectAsync
                        key={`productos[${index}]`}
                        name={`productos[${index}][producto_id]`}
                        placeholder={"Buscar..."}
                        noOptionsMessage={(query) => query?.inputValue.length > 0 ? `No se encontraron productos para "${query?.inputValue}"` : "Seleccione un cliente para empezar."}
                        loadingMessage={() => "Cargando..."}
                        defaultOptions={
                            productos && contacto &&
                            productos.map((producto) => ({
                                label: `${producto.referencia} ${producto.nombre}`,
                                value: producto.id,
                                producto: producto,
                            }))
                        }
                        loadOptions={(e) => getProductos("productos?limit=50&buscar="+e)}
                        value={
                            productoInfo.id && {
                                value: productoInfo.id,
                                label: productoInfo.nombre,
                                producto: productoInfo.producto,
                            }
                        }
                        onChange={(e) => onChangeProducto(e.value, e.producto)}
                        styles={{
                            singleValue: (provided, state) => ({
                                ...provided,
                                width: "100%",
                                display: "flex",
                            }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isSelected
                                    ? "rgba(152, 204, 245,.3)"
                                    : "white",
                                color: state.isSelected
                                    ? "#008aab"
                                    : "#666666",
                                fontWeight: state.isSelected
                                    ? "600"
                                    : "normal",
                            }),
                        }}
                        maxMenuHeight={200}
                        formatOptionLabel={(option, { context }) =>
                            option.producto
                                ? context === "value"
                                    ? (
                                        <span className="d-flex flex-column" style={{lineHeight: 1.1}}>
                                            <span style={{ fontWeight: "bold", fontSize: "11px" }}>
                                                {option.producto.referencia}
                                            </span>
                                            <span style={{whiteSpace: "normal"}}>{option.producto.nombre}</span>
                                        </span>
                                    )
                                    : productLabelMobile(option.producto)
                                : option.label
                        }
                    />
                    {productoInfo?.producto?.tipo === 'grupo' && (
                        <ul style={{padding: "10px 25px 0", margin: 0, lineHeight: 1.2, fontSize: "0.8rem"}}>
                            {productoInfo?.producto?.componentes?.map(item => (<li key={item.id}>{item.componente?.referencia} - {item.componente?.nombre} - Cant: {item.cantidad}</li>))}
                        </ul>
                    )}
                </div>
            </div>
            <div className="row">
                <div className="form-group col-6 pr-1 mb-1">
                    <label className="orden-filter-label">Cantidad</label>
                    <input
                        type="number"
                        name={`productos[${index}][cantidad]`}
                        placeholder="Cantidad"
                        value={productoInfo.cantidad || ''}
                        step="1"
                        min="1"
                        onChange={(e) => {
                            producto.cantidad = parseFloat(
                                e.target.value || 0
                            );
                            onChangeInput("cantidad", e.target.value);
                        }}
                        onBlur={() => checkQuantityConstrains()}
                        className="form-control"
                    />
                </div>
                <div className="form-group col-6 pl-1 mb-1">
                    <label className="orden-filter-label">Unidad</label>
                    <input type="hidden" name={`productos[${index}][unidad]`} value={productoInfo.unidadSeleccionada?.value ?? productoInfo.unidad ?? ""} />
                    <input type="hidden" name={`productos[${index}][factor]`} value={productoInfo.factor ?? 1} />
                    <input type="hidden" name={`productos[${index}][cantidad_base]`} value={aCantidadBase(productoInfo.cantidad, productoInfo.factor ?? 1)} />
                    <input type="hidden" name={`productos[${index}][unidad_id]`} value={productoInfo.unidadSeleccionada?.unidad_id ?? ""} />
                    <Select
                        placeholder="Und."
                        options={opcionesUnidades({ unidades: productoInfo.unidades })}
                        value={
                            productoInfo.unidadSeleccionada
                                ? {
                                        ...productoInfo.unidadSeleccionada,
                                        label: productoInfo.factor > 1
                                            ? `${productoInfo.unidadSeleccionada.value} (x${productoInfo.factor})`
                                            : productoInfo.unidadSeleccionada.value,
                                    }
                                : null
                        }
                        onChange={(opcion) => onChangeUnidad(opcion)}
                        isDisabled={(productoInfo.unidades?.length ?? 0) <= 1}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    />
                </div>
            </div>
            <div className="row">
                <div className="form-group col-6 pr-1 mb-1">
                    <label className="orden-filter-label">Importe</label>
                    <input
                        type="text"
                        className="form-control"
                        style={{ backgroundColor: "#fff" }}
                        value={formatCurrency(
                            money(productoInfo.costo),
                            ""
                        )}
                        readOnly
                    />
                    <input
                        type="hidden"
                        name={`productos[${index}][importe]`}
                        className="form-control"
                        value={productoInfo.costo}
                        readOnly
                    />
                </div>
                <div className="form-group col-6 pl-1 mb-1">
                    <label
                        className="orden-filter-label"
                        htmlFor="inputVendedor"
                    >
                        Impuesto
                    </label>
                    {/* !isVendedor() */ false  ? (
                        <>
                            <Select
                                placeholder="Impuesto"
                                onChange={(e) => onChangeImpuesto(e.value)}
                                value={productoInfo.impuesto}
                                isDisabled
                                options={impuestosForDropdown}
                            />
                            <input type="hidden" name={`productos[${index}][impuesto_id]`} value={productoInfo.impuesto || productoInfo.producto?.impuesto?.id} />
                        </>
                    ) : (
                        <>
                            <input
                                className="form-control"
                                value={productoInfo.impuesto?.label}
                                readOnly
                            />
                            <input
                                type="hidden"
                                name={`productos[${index}][impuesto_id]`}
                                value={productoInfo.impuesto?.value || productoInfo.producto?.impuesto?.id}
                            />
                        </>
                    )}
                </div>
            </div>
            <div className="row">
                <div className="form-group col-8 pr-1 mb-1">
                    <label className="orden-filter-label">Precio</label>
                    {!showPrecioManual ? (
                        <Select
                            type="text"
                            name={`productos[${index}][costo]`}
                            placeholder={"Seleccione..."}
                            loadingMessage={() => "Cargando"}
                            onChange={(e) => handlePrecioVentaChange(e)}
                            maxMenuHeight={200}
                            options={
                                [
                                    ...preciosVenta(),
                                    { value: "manual", label: "Manual" },
                                ] || []
                            }
                            value={productoInfo?.precio_venta || {}}
                        />
                    ) : (
                        <>
                            <input
                                type="number"
                                className="form-control"
                                name={`productos[${index}][costo]`}
                                value={precioManual}
                                id={`costo-${index}`}
                                onChange={(e) => {
                                    const svalue = e.target.value;
                                    setPrecioManual(svalue)
                                    console.log({productoInfo, svalue});
                                    setProductoInfo(prev => {
                                        return {
                                            ...prev,
                                            precio_manual: svalue
                                        }
                                    })
                                    onChangeCostoManual(svalue, false, productoInfo)
                                }}
                                onBlur={(e) => {
                                    onChangeCostoManual(e.target.value, true, productoInfo)
                                }}
                            />
                            <small
                                className="text-primary form-Text"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    volverAlSelector();
                                }}
                            >
                                Volver a selector
                            </small>
                        </>
                    )}
                </div>
                <div className="form-group col-4 pl-1 mb-1">
                    <label
                        className="orden-filter-label"
                        htmlFor="inputVendedor"
                    >
                        % Desc.
                    </label>
                    <input type="hidden" name={`productos[${index}][descuento]`} value="0" />
                    <input
                        type="number"
                        min="0"
                        name={`productos[${index}][descuento]`}
                        placeholder="Descuento"
                        value={productoInfo.descuento}
                        step="0.1"
                        onChange={(e) =>
                            onChangeInput("descuento", e.target.value)
                        }
                        className="form-control"
                    />
                </div>
            </div>
            {!showPrecioManual ? (
                <input
                    type="hidden"
                    name={`productos[${index}][precio_facturado]`}
                    value={total / productoInfo.cantidad}
                />
            ) : (
                <input
                    type="hidden"
                    name={`productos[${index}][precio_facturado]`}
                    value={precioManual}
                />
            )}
            <input
                type="hidden"
                name={`productos[${index}][total]`}
                value={total}
            />

            {productoInfo.fotos?.length > 0 && (
                <button
                    type="button"
                    className="btn btn-primary btn-block mb-2"
                    style={{ backgroundColor: "#008aab" }}
                    title="Ver Fotos"
                    onClick={() => toggleFotosModal()}
                >
                    Ver fotos
                </button>
            )}

            <div className="row px-3 justify-content-between align-items-center">
                <div className="form-group mb-0">
                    {!showPrecioManual ? (
                        <input
                            type="hidden"
                            name={`productos[${index}][precio_facturado]`}
                            value={productoInfo.costo + productoITBIS}
                        />
                    ) : (
                        <input
                            type="hidden"
                            name={`productos[${index}][precio_facturado]`}
                            value={precioManual}
                        />
                    )}
                    <input
                        type="hidden"
                        name={`productos[${index}][total]`}
                        value={total}
                    />
                    <label className="orden-filter-label">Total</label>
                    {formatCurrency(productoInfo.descuento > 0 ? totalReal : total)}
                </div>
                {auth.is("vendedor-admin") && productoInfo.id && (
                    <div className="d-inline-block text-center">
                        {!showPrecioCompra ? (
                            <button
                                type="button"
                                title="Ver Precio compra"
                                onClick={() => setShowPrecioCompra(true)}
                                className="producto"
                            >
                                <i className="fas fa-eye"></i>
                            </button>
                        ) : (
                            <p
                                onClick={() => setShowPrecioCompra(false)}
                                style={{ cursor: "pointer" }}
                            >
                                {formatCurrency(
                                    productoInfo.precioCompra
                                )}
                            </p>
                        )}
                    </div>
                )}
                <div className="text-right">
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() =>
                            isEdit
                                ? toggleDeleteModal()
                                : removeProducto(producto.id)
                        }
                    >
                        <i className="fas fa-trash"></i>
                    </button>
                </div>
            </div>
            {productoInfo?.fotos && (
                <Modal
                    show={showFotos}
                    blank={true}
                    toggle={() => setShowFotos((state) => !state)}
                >
                    <ItemFotos
                        toggle={() => setShowFotos((state) => !state)}
                        fotos={productoInfo.fotos}
                    />
                </Modal>
            )}
            <Modal
                title="Borrar Producto"
                show={showDelete}
                callback={() => removeProducto(producto.id)}
                acceptText="Borrar"
                toggle={toggleDeleteModal}
            >
                ¿Estás seguro de que deseas borrar este producto?
            </Modal>
            {errors[`productos.${index}.cantidad`] && (
                <small
                    className="help-blockParams form-Text d-block"
                    style={{ whiteSpace: "nowrap" }}
                >
                    {errors[`productos.${index}.cantidad`][0]}
                </small>
            )}
        </fieldset>
        {/* <---PIN DE SEGURIDAD MODAL--- */}
        <Modal
            title="PIN de seguridad"
            show={showPINModal}
            callback={() => checkPINSeguridad()}
            acceptText="Aceptar"
            toggle={() => togglePINModal()}
            size="419px"
        >
            <div className="form-group">
                <label>PIN de seguridad</label>
                <input
                    type="password"
                    className="form-control"
                    name="pin_seguridad"
                    value={pinSeguridad}
                    onChange={(e) => setPinSeguridad(e.target.value)}
                />
                <p
                    className="font-weight-bold"
                    style={{
                        color: "gray",
                        fontStyle: "italic",
                        lineHeight: "13px",
                        fontSize: "0.7rem",
                    }}
                >
                    Para continuar ingrese PIN de seguridad
                </p>
            </div>
        </Modal>
    </>;
};

export default ProductosCotizacionMobile;
